<template>
  <div class="sidebar-wrapper">
    <div class="sidebar">
      <div class="sidebar__heading">
        <h3 class="sidebar__title">Speaker Information</h3>
        <span @click="closeSpeakerbox()"
          ><svg
            width="30"
            height="30"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            /></svg
        ></span>
      </div>
      <div class="sidebar__description" v-for="speak in speaks" :key="speak.i">
        <div v-for="(item, j) in speak.photo" :key="j">
          <div class="speaker__image">
            <!-- <img
              src="../assets/arrow_detail.svg"
              alt="Arrow"
              class="speaker-arrow"
            /> -->
            <img class="speaker_image" :src="item.url" :alt="speak.name" />
          </div>
        </div>

        <h2>{{ speak.name }}</h2>
        <p class="speaker-position">
          <strong> {{ speak.position }}</strong>
        </p>
        <p class="speaker-company">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="#aeaeae"
          >
            <path
              fill-rule="evenodd"
              d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
              clip-rule="evenodd"
            /></svg
          >&nbsp;{{ speak.company }}
        </p>
        <br />
        <div>
          <p class="speaker-bio">{{ speak.bio }}</p>
          <ul>
            <li>
              <div v-if="speak.linkedin">
                <a :href="speak.linkedin" target="_blank"
                  ><svg
                    viewBox="0 0 119 119"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.1899 6.04279C9.00929 6.04279 3.66064 11.4146 3.66064 18.4751C3.66064 25.3796 8.84996 30.9046 16.876 30.9046H17.0313C25.3719 30.9046 30.5626 25.3796 30.5626 18.4751C30.4066 11.4146 25.3719 6.04279 17.1899 6.04279Z"
                    />
                    <path
                      d="M5.07422 40.7283H28.9896V112.679H5.07422V40.7283Z"
                    />
                    <path
                      d="M87.6906 39.0396C74.7891 39.0396 66.138 51.1628 66.138 51.1628V40.7283H42.2219V112.679H66.1366V72.4988C66.1366 70.3478 66.2926 68.2002 66.9245 66.662C68.6533 62.3667 72.5877 57.9169 79.1947 57.9169C87.8486 57.9169 91.3097 64.515 91.3097 74.1875V112.679H115.223V71.4237C115.223 49.3236 103.424 39.0396 87.6906 39.0396Z"
                    />
                  </svg>
                  {{ speak.linkedin }}</a
                >
              </div>
            </li>
            <li>
              <div v-if="speak.twitter">
                <a :href="speak.twitter" target="_blank"
                  ><svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0)">
                      <path
                        d="M48 9.117C46.215 9.9 44.313 10.419 42.33 10.671C44.37 9.453 45.927 7.539 46.659 5.232C44.757 6.366 42.657 7.167 40.419 7.614C38.613 5.691 36.039 4.5 33.231 4.5C27.783 4.5 23.397 8.922 23.397 14.343C23.397 15.123 23.463 15.873 23.625 16.587C15.444 16.188 8.205 12.267 3.342 6.294C2.493 7.767 1.995 9.453 1.995 11.268C1.995 14.676 3.75 17.697 6.366 19.446C4.785 19.416 3.234 18.957 1.92 18.234C1.92 18.264 1.92 18.303 1.92 18.342C1.92 23.124 5.331 27.096 9.804 28.011C9.003 28.23 8.13 28.335 7.224 28.335C6.594 28.335 5.958 28.299 5.361 28.167C6.636 32.064 10.254 34.929 14.556 35.022C11.208 37.641 6.957 39.219 2.355 39.219C1.548 39.219 0.774 39.183 0 39.084C4.359 41.895 9.525 43.5 15.096 43.5C33.204 43.5 43.104 28.5 43.104 15.498C43.104 15.063 43.089 14.643 43.068 14.226C45.021 12.84 46.662 11.109 48 9.117Z"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect width="48" height="48" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  {{ speak.twitter }}</a
                >
              </div>
            </li>
            <li>
              <div v-if="speak.website">
                <a :href="speak.website" target="_blank"
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z"
                      clip-rule="evenodd"
                    /></svg
                  >{{ speak.website }}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "../main";
export default {
  name: "SidebarSpeaker",
  props: {
    speaks: {
      type: Array,
      required: true,
    },
  },
  methods: {
    closeSpeakerbox() {
      bus.$emit("closeSideboxSpeaker");
      document.body.classList.remove("overflow-fix");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.speaker-workplace {
  display: flex;
  align-items: center;
  margin: 2rem 0rem;
}
.speaker-company {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  color: var(--lighter-grey);
}
.speaker-arrow {
  width: 100%;
  display: block;
  position: absolute;
}
.speaker-bio {
  margin: 1rem 0rem 4rem 0rem;
}
h2 {
  color: var(--primary-color);
  margin-top: 1rem;
}
.speaker__image {
  margin: 0 auto;
}
.sidebar {
  max-width: 550px;
  margin-left: auto;
  background-color: var(--bg-black);
  box-sizing: border-box;
  color: var(--text-white);
  overflow: auto;
}
.sidebar__description {
  position: relative;
  padding: 0 2rem 2rem 2rem;
}
.sidebar-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.69);
}
.sidebar__heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 999;
  padding: 2rem;
  background-color: var(--bg-black);
}
.sidebar__heading span {
  cursor: pointer;
}
.speaker__image .speaker_image {
  text-align: center;
  margin-right: auto;
  width: 60%;
  position: relative;
}
.speaker__image {
  position: relative;
}
.speaker-arrow {
  left: 0;
  right: 0;
  width: 47%;
  bottom: 0;
  position: absolute;
  margin: auto;
  z-index: 999;
}
.sidebar__description ul {
  display: flex;
  flex-direction: column;
}
.sidebar__description ul li {
  display: flex;
  align-items: center;
  color: var(--primary-color);
}
.sidebar__description ul li a {
  color: var(--primary-color);
  display: flex;
  align-items: center;
  word-break: break-word;
}
.sidebar__description ul li a > svg {
  width: 20px;
  margin-right: 1rem;
  fill: var(--primary-color);
}
@media (max-width: 576px) {
  .sidebar {
    width: 100%;
    max-width: 100%;
  }
}
</style>
